import _ from 'lodash'

import { NPS_STRATEGY } from '@/api/apiModules'
export default {
  // confirm: {
  //   msg: '选择的内容是否正确，确认后已收集过的对应平台/工具的记录将删除'
  // },
  viewType: 'form',
  module: NPS_STRATEGY,
  params: {},
  needFetchFillInfo: false,
  //callBackAction: 'AsAfterClear',
  formatData(data) {
    if (data.tool) {
      data.toolId = data.tool.id
    }
    return data
  },
  view: {
    labelPosition: 'right',
    labelWidth: '225px',
    width: '725px',
    content: [
      {
        $id: 'npsStrategy',
        $type: 'select',
        label: '采集开启策略',
        $el: {
          filterable: true,
          clearable: true
        },
        $options: 'global/enum/npsStrategy',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.label
            }
          })
          return value ? value : ''
        },
        rules: [
          {
            notEmpty: '采集开启策略'
          }
        ]
      },
      {
        $id: 'tool',
        $type: 'sky-relation-option',
        label: '工具',
        $el: {
          multiple: false
        },
        actions: {
          nativeOn: {
            click: 'RelationTool'
          }
        },
        rules: [
          {
            notEmpty: '工具'
          }
        ]
      },
      {
        $id: 'bbb',
        $type: 'sky-alert-description',
        $el: {
          description: [
            '1、首次使用后开启NPS：工具第一次使用或下载即开启采集准备',
            '2、项目创建后开启NPS：创建项目后开启采集准备',
            '3、项目结束后开启NPS：项目结束后开启采集准备',
            '4、每个人每个工具只采集一次NPS',
            '5、从准备采集到正式采集间隔7天'
          ],
          type: 'warning'
        }
      }
    ]
  }
}
